/* mm-ugc-row: <mm-ugc-video> plays its muted, looping video while at least 60% of it is on screen and pauses it when
   it scrolls away (sections/mm-ugc-row.liquid). The button toggles play/pause; once a shopper pauses a video it stays
   paused. With data-autoplay off or reduced motion, videos only play when the button is pressed.
   A custom element, so it re-initialises itself when the theme editor re-renders the section. */
(() => {
  if (customElements.get('mm-ugc-video')) return;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  customElements.define('mm-ugc-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-toggle]');
      if (!this.video) return;
      this.ac = new AbortController();
      const opts = { signal: this.ac.signal };
      this.held = !this.hasAttribute('data-autoplay') || still.matches;
      this.inView = false;
      this.button?.addEventListener('click', () => {
        if (this.video.paused) { this.held = false; this.play(); }
        else { this.held = true; this.video.pause(); }
      }, opts);
      this.video.addEventListener('play', () => this.render(), opts);
      this.video.addEventListener('pause', () => this.render(), opts);
      this.io = new IntersectionObserver(([entry]) => {
        this.inView = entry.intersectionRatio >= 0.6;
        if (!this.inView) this.video.pause();
        else if (!this.held) this.play();
      }, { threshold: [0, 0.6] });
      this.io.observe(this);
      this.render();
    }

    disconnectedCallback() {
      this.ac?.abort();
      this.io?.disconnect();
    }

    play() {
      this.video.muted = true;
      this.video.play()?.catch(() => this.render());
    }

    render() {
      const playing = !this.video.paused;
      this.toggleAttribute('data-playing', playing);
      if (this.button) this.button.setAttribute('aria-label', playing ? this.button.dataset.pause : this.button.dataset.play);
    }
  });
})();
